import dynamic from "next/dynamic";
import Link from "next/link";
import React from "react";
import { FaFacebook, FaInstagramSquare, FaTwitterSquare } from "react-icons/fa";

const Item = dynamic(() => import("./Item"));

const UsefulLinks = () => {
  return (
    <div className="w-full">
      <div className="border-b border-white">
        <h2 className="text-white">Useful Links</h2>
      </div>
      <div className="text-white pt-2 flex flex-col gap-1">
        <Item search="/blogs" title="Blog" />
        <Item search="/calculators" title="Mortgage Calculators" />
        <Item
          search="/land-transfer-tax-calculator"
          title="Land Transfer Tax Calculator"
        />
        <Item search="/contact-us" title="Contact Us" />
        <Item search="/sitemap" title="Sitemap" />
        <Item search="/terms" title="Privacy Policy" />
      </div>
      <div className="pt-2 flex gap-2 text-3xl text-white">
        <Link href={"https://www.facebook.com/bungalowfinder.ca"} passHref>
          <a target="_blank">
            <FaFacebook className="cursor-pointer" />
          </a>
        </Link>
        <Link href={"https://www.twitter.com"}>
          <a target="_blank">
            <FaTwitterSquare className="cursor-pointer" />
          </a>
        </Link>
        <Link href={"https://www.instagram.com/bungalowfinder.ca/"}>
          <a target="_blank">
            <FaInstagramSquare className="cursor-pointer" />
          </a>
        </Link>
      </div>
    </div>
  );
};

export default UsefulLinks;
